import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { generateKey } from '../../utils/utils';

const GroupedTableHead = ({ tableHeadData, className, isVisible = true }) => {
  if (isVisible) {
    if (Array.isArray(tableHeadData)) {
      return (
        <thead className={className} data-testid="grouped-table-head">
          <tr>
            {tableHeadData.map((column, index) => {
              return (
                <th
                  style={{ width: column.columnWidth }}
                  key={generateKey(column.columnLabel, index)}
                >
                  {column.columnLabel}
                </th>
              );
            })}
          </tr>
        </thead>
      );
    } else {
      console.warn(
        'GroupedTableHead received invalid arguments - tableHeadData:',
        tableHeadData
      );
      return null;
    }
  } else {
    return null;
  }
};

GroupedTableHead.propTypes = {
  tableHeadData: PropTypes.array,
};

const StyledGroupedTableHead = styled(GroupedTableHead)``;

export default StyledGroupedTableHead;
